import * as React from 'react';

const ContactPage = (props) => {
    return (
        <div>
            <h2>Contact Us</h2>
        </div>
    );
};

export default ContactPage;